import axios from 'axios';
import { getTokenbyKey } from '../authenticated-user';
import encode from '../token';
import { ToastFunction, useErrorToast } from '../../hooks/toast';
import { waitSomeTime } from '../wait-some-time';

const APIVERSION = 'application/vnd.br.com.sihmma.api.v2+json';
const defaultHeaders = { Accept: 'application/json', ['X-API-Version']: APIVERSION };

const createAxiosInstance = async (sessionKey: string = 'CRM') => {
  const token = getTokenbyKey(sessionKey);
  const encodeToken = token ? await encode(token, false) : null;
  const instance = axios.create({
    // eslint-disable-next-line no-undef
    baseURL: process.env.REACT_APP_BACKEND_SERVER_URL,
    timeout: 100000,
    headers: encodeToken
      ? { ...defaultHeaders, Authorization: `Bearer ${encodeToken}` }
      : defaultHeaders,
  });

  instance.interceptors.request.use(
    function (config) {
      document.body.classList.add('loading-indicator');
      return config;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response) => {
      document.body.classList.remove('loading-indicator');
      return response;
    },
    async (error) => {
      document.body.classList.remove('loading-indicator');
      if ([401, 403].includes(error?.response?.status)) {
        handleSessionExpiration(sessionKey);
      }
      if ([413].includes(error?.response?.status)) {
        handleUploadSizeError();
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export const handleSessionExpiration = async (sessionKey: string = 'CRM') => {
  const errorToash: ToastFunction = useErrorToast();

  errorToash('Sua sessão expirou, por favor realize o login novamente!');

  if (sessionKey === 'CRM') {
    localStorage.removeItem('CRM');
    sessionStorage.removeItem('CRM');
    await waitSomeTime(2000);
    window.location.href = '/admin/login';
    return;
  }
  localStorage.removeItem('customer');
  sessionStorage.removeItem('customer');
  window.location.href = '/login';
};

export const handleUploadSizeError = async () => {
  const errorToash: ToastFunction = useErrorToast();

  errorToash('Upload de arquivos muito grande! O limite é 10MB por requisição.');
};

export default createAxiosInstance;
